export enum ConditionTypeEnum {
    And = 0,
    Or = 1
}